import { Helmet } from "react-helmet";
import { Event } from "../types/event";

const EventSchema = ( props: { config:any, event: Event, coordinates: number[] } ) => {
    const { config, event, coordinates } = props;
    const prefecture = config.code_master.pref.filter((pre: any) => pre.cd === event.prefecture)[0].name ?? "不明";
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "Event",
        "name": event.title,
        "startDate": `${event.startDate}T${event.startTime ?? "00:00"}`,
        "endDate": `${event.endDate}T${event.endTime ?? "00:00"}`,
        "description": event.description,
        "location": {
            "@type": "Place",
            "name": event.place,
            "geo": {
                "@type": "GeoCoordinates",
                "latitude": coordinates[1] ?? 0,
                "longitude": coordinates[0] ?? 0
            },
            "address": {
                "@type": "PostalAddress",
                "addressRegion": prefecture,
                "addressCountry": "JP"
            }
        },
        "offers": {
            "@type": "Offer",
            "url": event.url,
            "availability": "https://schema.org/InStock"
        },
        "eventStatus": "https://schema.org/EventScheduled",
        "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode"
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(structuredData)}
            </script>
        </Helmet>
    );
};

export default EventSchema;